import { useSyncExternalStore } from 'react';
import { demoEstActif, suivreDemo } from '../demo';

/**
 * Bannière de démonstration.
 *
 * Elle reste affichée en permanence, en tête du panneau, tant que le plugin
 * sert les jeux d'exemple. C'est la contrepartie non négociable du mode
 * démonstration : une synthèse d'exemple prise pour l'état réel d'un dossier
 * ferait exactement le dégât que ce plugin est censé éviter — et ces jeux
 * portent des noms de vrais clients.
 */
export function BandeauDemo() {
  const actif = useSyncExternalStore(suivreDemo, demoEstActif, demoEstActif);
  if (!actif) return null;

  return (
    <div className="demo" role="status">
      <strong>Données d’exemple</strong>
      <span>
        Le pipeline ne sert pas encore l’API : tout ce qui s’affiche ici vient des
        jeux de démonstration du contrat. Rien n’est l’état réel d’un dossier.
      </span>
    </div>
  );
}
